module.exports = __webpack_public_path__ + "img/pierogi.3bdb9377.png";